module.exports = __webpack_public_path__ + "static/img/jigou-dalian-bottom.6825ba0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-dalian-bottom.png
// module id = DD8m
// module chunks = 2